import { observable, computed, action } from 'mobx'
import { InvoiceStatus, InvoicePaidStatus } from '@getgreenline/homi-shared'

export interface InvoiceFilter {
  customId?: string
  title?: string
  locationId?: number
  paid?: InvoicePaidStatus
  status?: InvoiceStatus
  employeeId?: string
  supplierId?: number
  startingUserId?: string
  offset: number
  limit: number
  productIds: string[]
  startDate?: Date
  endDate?: Date
}

export class Filter {
  @observable
  history: any

  @observable
  customId?: string

  @observable
  title?: string

  @observable
  locationId?: number

  @observable
  paid?: InvoicePaidStatus

  @observable
  employeeId?: string

  @observable
  supplierId?: number

  @observable
  status?: InvoiceStatus

  @observable
  // Currently isn't stored via the url
  selectedProducts: Array<{ id: string; name: string }> = []

  @observable
  offset: number

  @observable
  limit = 30

  @observable
  startDate?: Date

  @observable
  endDate?: Date

  // When starting up, check the query parameters for values. Otherwise, fill them in
  constructor(history: any) {
    this.history = history

    const initialQuery = history.getCurrentLocation().query

    // If url params exist, fill them in
    if (initialQuery.customId) {
      this.customId = initialQuery.customId || ''
    }
    if (initialQuery.title) {
      this.title = initialQuery.title || ''
    }
    if (initialQuery.locationId) {
      this.locationId = parseInt(initialQuery.locationId)
    }
    if (initialQuery.paid) {
      this.paid = initialQuery.paid
    }
    if (initialQuery.employeeId) {
      this.employeeId = initialQuery.employeeId
    }
    if (initialQuery.supplierId) {
      this.supplierId = parseInt(initialQuery.supplierId, 10)
    }
    if (initialQuery.status) {
      this.status = initialQuery.status
    }
    if (initialQuery.offset) {
      this.offset = parseInt(initialQuery.offset, 10)
    } else {
      this.offset = 0
    }
    if (initialQuery.limit) {
      this.limit = parseInt(initialQuery.limit, 10)
    }

    if (initialQuery.startDate) {
      this.startDate = initialQuery.startDate
    }

    if (initialQuery.endDate) {
      this.endDate = initialQuery.endDate
    }
    // Replace instead of push because we don't want user's back button behavior to be affected by this initial population
    history.replace({
      pathname: history.getCurrentLocation().pathname,
      query: this.networkObject,
    })
  }

  @computed
  get networkObject(): InvoiceFilter {
    const productIds = this.selectedProducts.map((selectedProduct) => selectedProduct.id)
    return {
      customId: this.customId || undefined,
      title: this.title || undefined,
      locationId: this.locationId,
      paid: this.paid,
      status: this.status,
      employeeId: this.employeeId,
      supplierId: this.supplierId,
      startingUserId: this.employeeId,
      offset: this.offset,
      limit: this.limit,
      productIds: productIds,
      startDate: this.startDate,
      endDate: this.endDate,
    }
  }

  apply() {
    this.history.replace({
      pathname: this.history.getCurrentLocation().pathname,
      query: this.networkObject,
    })
  }

  @action
  reset = () => {
    this.customId = undefined
    this.title = undefined
    this.locationId = undefined
    this.paid = undefined
    this.status = undefined
    this.employeeId = undefined
    this.supplierId = undefined
    this.selectedProducts = []
    this.startDate = undefined
    this.endDate = undefined
  }

  @action
  setStartDate(date: Date | null) {
    this.startDate = date || undefined
  }

  @action
  setEndDate(date: Date | null) {
    this.endDate = date || undefined
  }
}
